<template>
  <div class="evaluation-answer-range">
    <el-slider
      v-model="internalValue"
      input-size="large"
      @change="onChange"
      :max="100"
      :show-stops="false"
      :disabled="disabled"
    />
    <p>
      <b>Respuesta:</b> {{ internalValue }}
    </p>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationAnswerRange',
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      required: true
    },
    branchType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      internalValue: 0
    }
  },
  mounted () {
    this.calculateBaseScore()
    this.internalValue = this.question.$result
  },
  methods: {
    calculateBaseScore () {
      this.question.$baseScore = 0
      for (let answer of this.question.$answers) {
        if (answer.$pointsPerBranch) {
          for (let branchPoints of answer.$branchPoints) {
            if (branchPoints.type === this.branchType) {
              if (this.question.$baseScore < branchPoints.points) {
                this.question.$baseScore = branchPoints.points
              }
            }
          }
        } else {
          if (this.question.$baseScore < answer.$points) {
            this.question.$baseScore = answer.$points
          }
        }
      }
    },
    onChange (index) {
      let answer = this.question.$answers[0]
      this.question.$result = index
      console.log(answer)
      if (answer.$pointsPerBranch) {
        console.log(answer)
        for (let branchPoints of answer.$branchPoints) {
          if (branchPoints.type === this.branchType) {
            this.question.$points = branchPoints.points
            break
          }
        }
      } else {
        this.question.$points = answer.$points
      }
      this.question.$points = this.question.$points * (index / 100)
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evauation-answer-slider {
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/answers/evaluation-answer-range.vue